import type { AxiosRequestConfig } from "axios";
import type { IPaginated, IRepositoryOptions } from "@/types/common";
import type { ILender } from "@/types/companies-lenders";
import { BaseRepository } from "../BaseRepository";
import type { LendersService } from "./service";
import type {
  IDeleteLenderRequest,
  IGetLenderByIdRequest,
  IGetLendersRequest,
  IUpdateLenderLogoRequest,
  IUpsertLenderInput,
} from "./types";

export class LendersRepository extends BaseRepository {
  constructor(
    private readonly service: LendersService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAll(
    p: IGetLendersRequest,
    c?: AxiosRequestConfig,
  ): Promise<IPaginated<ILender>> {
    const response = await this.handleRequest(this.service.getAll, p, c);
    return response.data;
  }

  async getCompanyDetails(
    p: IGetLenderByIdRequest,
    c?: AxiosRequestConfig,
  ): Promise<ILender> {
    const response = await this.handleRequest(
      this.service.getCompanyDetails,
      p,
      c,
    );
    return response.data;
  }

  async upsertCompany(
    p: IUpsertLenderInput,
    c?: AxiosRequestConfig,
  ): Promise<ILender> {
    const p2 = new FormData();

    p2.append(
      "lender",
      new Blob([JSON.stringify(p.lender)], {
        type: "application/json",
      }),
    );

    if (p.logo) {
      p2.append("logo", p.logo[0]);
    }

    const response = await this.handleRequest(
      this.service.upsertCompany,
      p2,
      c,
    );
    return response.data;
  }

  async deleteCompany(
    p: IDeleteLenderRequest,
    c?: AxiosRequestConfig,
  ): Promise<void> {
    const response = await this.handleRequest(this.service.deleteCompany, p, c);
    return response.data;
  }

  async updateLogo(
    p: IUpdateLenderLogoRequest,
    c?: AxiosRequestConfig,
  ): Promise<ILender> {
    const response = await this.handleRequest(this.service.updateLogo, p, c);
    return response.data;
  }
}
